module.exports = __webpack_public_path__ + "img/mont2.a413d676.png";